export default {"src":"/_next/static/media/0x4338665cbb7b2485a8855a139b75d5e34ab0db94.58215838.svg","height":83,"width":83,"blurWidth":0,"blurHeight":0};